import { jsx, jsxs } from "react/jsx-runtime";
import { ListItem, Typography } from "@mui/material";
import { EndAdornmentContainer } from "./components/EndAdornmentContainer.js";
import { OptionContainer } from "./components/OptionContainer.js";
function ItemRenderer(props) {
  const {
    option,
    itemProps,
    getOptionLabel,
    ItemEndAdornment,
    autoCompleteState: { selected },
    selectState,
    selectState: {
      props: { density = "normal" }
    }
  } = props;
  const padding = density === "comfortable" ? 1.5 : density === "normal" ? 1 : 0;
  return /* @__PURE__ */ jsx(ListItem, { ...itemProps, disablePadding: true, disableGutters: true, children: /* @__PURE__ */ jsxs(OptionContainer, { sx: { padding }, children: [
    /* @__PURE__ */ jsx(Typography, { noWrap: true, children: getOptionLabel(option) }),
    ItemEndAdornment && /* @__PURE__ */ jsx(EndAdornmentContainer, { children: /* @__PURE__ */ jsx(ItemEndAdornment, { option, selected, selectState }) })
  ] }) });
}
export {
  ItemRenderer
};
//# sourceMappingURL=ItemRenderer.js.map
